import { useMemo, useState } from 'react';
import { DefaultTheme, withTheme } from 'styled-components';

import ErrorIcon from '../../../assets/svg/error-icon-white.svg';
import InfoModal from '../../Modal/InfoModal';
import AlertBar from '../AlertBar';

interface DisconnectAlertProps {
  theme: DefaultTheme;
  forecastIsStaleError: boolean;
}

const DisconnectAlert: React.FC<DisconnectAlertProps> = ({ theme, forecastIsStaleError }) => {
  const [showModal, setShowModal] = useState(false);

  const modalContent = useMemo(
    () => (
      <div>
        <strong>Optimise will keep trying to reconnect to your inverter.</strong>
        <br />
        <br />
        There may be an issue with the inverter's connection to your WiFi. Please ensure the inverter has a good
        connection to your router and is always connected (don't turn it off).
        {forecastIsStaleError && (
          <>
            <br />
            <br />
            If only a partial connection can be established, your system will enter a ‘hold’ state. In this mode, it
            will continue to charge from your solar generation and, if needed, discharge to support your home’s energy
            use - but only down to your preset minimum state of charge.
          </>
        )}
      </div>
    ),
    [forecastIsStaleError]
  );

  return (
    <>
      <InfoModal show={showModal} onClose={() => setShowModal(false)} infoContent={modalContent} />
      <AlertBar
        label={
          <div>
            Your inverter appears to be offline, {theme.language.appName} will keep trying to reconnect.{' '}
            <u>Find out more</u>
          </div>
        }
        icon={ErrorIcon}
        onClick={() => setShowModal(true)}
        variant="danger"
      />
    </>
  );
};

export default withTheme(DisconnectAlert);
